import React, { useEffect, useState } from 'react';
import './ModalContentView.scss';
import { classNameBuilder } from '../../../utils/className';
import Typography from '../../Typography/Typography';
import Button from '../../Button/Button';
import { isValidEmail } from '../../../utils/validation';
import InputField from '../../InputField/InputField';
import Turnstile from 'react-turnstile';

interface IProps {
    required?: boolean;
    className?: string;
    title?: string;
    typeTitle?: any;
    titlePosition?: 'center' | 'left';
    text?: string;
    input?: {
        theme?: 'light' | 'dark';
        onChange: (e: any) => void;
    };
    btnPosition?: 'center' | 'left' | 'space-between' | 'space-around';
    button?: {
        disabled?: boolean;
        name: string;
        border?: boolean;
        theme?: 'light' | 'dark';
        onAction?: () => void;
        position?: 'center' | 'left';
    }[];
    onTokenChange?: (newToken: string) => void;
}

export const ModalContentView: React.FC<IProps & { showTurnstile?: Boolean }> = ({
    className,
    required = false,
    title,
    typeTitle = 'h2',
    text,
    button,
    input,
    btnPosition = 'left',
    titlePosition = 'left',
    onTokenChange,
    showTurnstile = false,
}) => {
    const cn = classNameBuilder('modal-content-view');
    const [isValid, setValid] = useState(false);
    const [email, setEmail] = useState('');
    const [token, setToken] = useState('');
    const [isFormButtonClicked, setFormButtonClicked] = useState(false);

    useEffect(() => {
        if (onTokenChange) {
            onTokenChange(token);
        }
    }, [token]);

    const validateEmail = (value: string) => {
        if (isValidEmail(value)) {
            if (token) {
                setValid(true);
            }
        } else {
            setValid(false);
        }
    };

    useEffect(() => {
        validateEmail(email);
    }, [email]);

    const handleClick = (onAction?: () => void) => {
        if (onAction) {
            if (!required) {
                onAction();
            } else if (required && isValid) {
                onAction();
            } else setFormButtonClicked(true);
        }
    };

    return (
        <div className={`${cn('', { title: titlePosition })} ${className}`}>
            {title && (
                <Typography variant={typeTitle} wordBreak={false}>
                    {title}
                </Typography>
            )}
            {text && <Typography size={'18px'}>{text}</Typography>}
            {input && (
                <InputField
                    required={required}
                    theme={input.theme}
                    value={email}
                    onChange={(e) => {
                        setEmail(e.target.value);
                        input?.onChange(e.target.value);
                    }}
                    name="email"
                    type="text"
                    placeholder="Ваш e-mail"
                    isValid={isValid}
                    isValidationLaunchedByClick={isFormButtonClicked}
                    helper={isValid ? '' : 'Введите корректный email'}
                    isValidFocus={true}
                />
            )}
            {showTurnstile && (
                <div className={cn('turnstile-container', { position: btnPosition })}>
                    <Turnstile
                        sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY || ''}
                        onVerify={(token: string) => {
                            setToken(token);
                        }}
                    />
                </div>
            )}
            {button && (
                <div className={cn('row-btn', { position: btnPosition })}>
                    {button?.map((value, index) => {
                        return (
                            <Button
                                key={index}
                                disabled={required && !isValid}
                                scheme={value.theme}
                                border={value?.border ? 'dark' : 'none'}
                                onClick={() => handleClick(value.onAction)}>
                                {value.name}
                            </Button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};
